export default {"src":"/_next/static/media/SearchIcon.d4ce2894.svg","height":16,"width":17};